const { removeSsnYearPrefix } = require('../../utils/ssn')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string} country
 * @param {*} value
 * @param {*} validationValue
 * @returns {boolean}
 */
function uniqueSsn ({ country, value, validationValue }) {
  if (!validationValue) return true

  value = removeSsnYearPrefix({ country, value })
  validationValue = removeSsnYearPrefix({ country, value: validationValue })

  return (value !== validationValue)
}

module.exports = { uniqueSsn }
